"use strict";

import ItemContentView from "/js/interaction-views/item-content-view.js";
import Constants from '/js/core/constants.js';
import FocusUtil from '/js/util/focus-util.js';

/**
 * Very similar to the ItemContentView used for the "multiple-choice" interaction type.
 */
export default class QuestionnaireMultipleChoiceItemContentView extends ItemContentView {
  
  constructor(questionObject, index, numItems) {
    
    super(questionObject, index, numItems);
    
    let buttonsString = "";
    questionObject.choices.forEach((choice, i) => {      
      buttonsString += `\
        <div class='button interaction-big-button' 
            data-buttonIndex='${ i }'
            data-countKey='${ choice.countKey }' 
            data-resultKey='${ choice.resultkey }'
            tabindex="${Constants.TABINDEX_CONTENT_GENERAL}" 
            > 
          ${ choice.title }
        </div>`;
    }, this);

    const s = `\
        <div class="prompt">${ questionObject.question }</div>
        ${ buttonsString }`;
    const $els = $(s);      
    this.$content.append($els);

    const $buttons = this.$content.find(".button");
    for (const button of $buttons) {
      const $button = $(button);
      $button.on("click tap", e => this.#onButton(e));
      FocusUtil.doStandardTreatment($button);
    }

  }

  /* Override */
  onShow() {
    super.onShow();
    // In case previous item had text input, hide virtual keyboard.
    document.activeElement.blur();
  }

  #onButton(e) {
    const buttonIndexString = $(e.target).attr('data-buttonIndex');
    const buttonIndex = parseInt(buttonIndexString);
    const content = [buttonIndex];  // note how is wrapped in an array
    const o = {
        index: this.index,
        content: content
    };
    this.$el.trigger('content-view', o);
  }
}
